// Subscriptions-specific table state mappings
import { getSingleValue, getArrayValue } from '@/lib/utils/table-state-utils';

export const subscriptionsFilterMapping = {
    store: (value: any) => {
        return { storeIds: getArrayValue(value) };
    },
    status: (value: any) => {
        return { 'subscriptions.status': getArrayValue(value) };
    },
    trial: (value: any) => {
        return { 'subscriptions.trial': getSingleValue(value) };
    },
    processor: (value: any) => {
        return { preferredProcessorId: getArrayValue(value) };
    },
    cardVault: (value: any) => {
        return { useTagadaVault: getArrayValue(value) };
    },
    plan: (value: any) => {
        return { priceInterval: getArrayValue(value) };
    },
    amount: (value: any) => {
        if (value && typeof value === 'object' && 'condition' in value) {
            const result = { price: value };
            return result;
        }
        return undefined;
    },
    createdAt: (value: any) => ({
        'subscriptions.createdAt': value
    }),
    updatedAt: (value: any) => ({
        'subscriptions.updatedAt': value
    }),
    nextBillingDate: (value: any) => ({
        nextBillingDate: value
    }),
};

export const subscriptionQueryParamsMapping = {
    store: (value: URLSearchParams) => {
        return value.get('store')?.split(',')
    },
    status: (value: URLSearchParams) => {
        return value.get('status')?.split(',')
    },
    trial: (value: URLSearchParams) => {
        return value.get('trial')
    },
    processor: (value: URLSearchParams) => {
        return value.get('processor')?.split(',')
    },
    cardVault: (value: URLSearchParams) => {
        return value.get('cardVault')?.split(',')
    },
    plan: (value: URLSearchParams) => {
        return value.get('plan')?.split(',')
    },
    amount: (value: URLSearchParams) => {
        return value.get('amount')
    },
    createdAt: (value: URLSearchParams) => {
        const res = value.get('createdAt')
        return res ? JSON.parse(res) : null
    },
    updatedAt: (value: URLSearchParams) => {
        const res = value.get('updatedAt')
        return res ? JSON.parse(res) : null
    },
    nextBillingDate: (value: URLSearchParams) => {
        const res = value.get('nextBillingDate')
        return res ? JSON.parse(res) : null
    },
}

// Sort field mappings for subscriptions (frontend column ID -> backend sort field)
export const subscriptionsSortMapping = {
    id: 'subscriptions.id' as const,
    status: 'subscriptions.status' as const,
    createdAt: 'subscriptions.createdAt' as const,
    nextBillingDate: 'subscriptions.nextBillingDate' as const,
    price: 'subscriptions.price' as const,
    amount: 'subscriptions.price' as const, // Map amount column to price sort
    customerEmail: 'customers.email' as const,
    customer: 'customers.fullName' as const,
    store: 'stores.name' as const, // Map store column ID
    storeName: 'stores.name' as const,
    processor: 'processors.name' as const, // Map processor column ID
    processorName: 'processors.name' as const,
    updatedAt: 'subscriptions.updatedAt' as const,
} as const;
